import { render } from "./FormInputWrapper.vue?vue&type=template&id=b4dc6906&ts=true"
import script from "./FormInputWrapper.vue?vue&type=script&lang=ts"
export * from "./FormInputWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__